/**
 * Entity kinds the result-card renderer can project, plus the tool-name maps
 * that decide which card (if any) a tool result gets.
 *
 * Adding a tool here is the ONLY thing needed to give it a typed card — the
 * renderers are shape-driven and fall back to the generic JSON view whenever
 * the output doesn't project.
 */

/** Entity kinds we can card-render, with their Hub detail routes. */
export type EntityKind = 'contact' | 'company' | 'deal' | 'task' | 'ticket';

export const ENTITY_ROUTES: Record<EntityKind, string> = {
  contact: '/contacts',
  company: '/companies',
  deal: '/deals',
  task: '/tasks',
  ticket: '/tickets',
};

export const ENTITY_NOUNS: Record<EntityKind, string> = {
  contact: 'contact',
  company: 'company',
  deal: 'deal',
  task: 'task',
  ticket: 'ticket',
};

/** toolName → entity kind, for list/search/find/get result cards. */
export const LIST_TOOL_ENTITIES: Record<string, EntityKind> = {
  find_contact: 'contact',
  search_contacts: 'contact',
  list_contacts: 'contact',
  find_company: 'company',
  search_companies: 'company',
  list_companies: 'company',
  find_deal: 'deal',
  search_deals: 'deal',
  list_deals: 'deal',
  get_deals_by_stage: 'deal',
  list_deals_needing_followup: 'deal',
  list_deals_needing_quotes: 'deal',
  get_task: 'task',
  list_tasks: 'task',
  search_tasks: 'task',
  get_ticket: 'ticket',
  list_tickets: 'ticket',
  search_ticket: 'ticket',
};

/** toolName → entity kind, for mutation receipts. */
export const MUTATION_TOOL_ENTITIES: Record<string, EntityKind> = {
  create_contact: 'contact',
  edit_contact: 'contact',
  create_company: 'company',
  edit_company: 'company',
  create_deal: 'deal',
  update_deal: 'deal',
  create_task: 'task',
  update_task: 'task',
  create_ticket: 'ticket',
  update_ticket: 'ticket',
};
